import classNames from "classnames"
import React from "react"
import style from "./index.module.css"

export interface CustomTextAreaProps {
  className?: string
  label?: string
  name: string
  placeholder?: string
  inputRef?: React.Ref<any>
}

const CustomTextArea = ({
  className,
  label,
  placeholder,
  name,
  inputRef,
}: CustomTextAreaProps) => {
  return (
    <textarea
      className={classNames(
        "w-full border-solid border-0 border-b-2 border-lightBlack bg-trasparent resize-none",
        className,
        style.textarea
      )}
      name={name}
      ref={inputRef}
      placeholder={placeholder ? placeholder : label}
      rows={5}
    />
  )
}
export default CustomTextArea
